import { render, staticRenderFns } from "./Foyda.vue?vue&type=template&id=5c0fd332&scoped=true"
import script from "./Foyda.vue?vue&type=script&lang=js"
export * from "./Foyda.vue?vue&type=script&lang=js"
import style0 from "./Foyda.vue?vue&type=style&index=0&id=5c0fd332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0fd332",
  null
  
)

export default component.exports